<template>
<div id="contentWrap">
  <div class="content left">
    <div id="content_1block" class="left">
      <div id="content_top">
        <div class="content_title_full left">Forgot Password</div>
      </div>
      <div class="msgblock">Please enter your registered email in the box below. An email will be sent to you to reset password.</div>
      <div class="pure-form pure-form-aligned">
        <fieldset style="margin-left: 120px;">
          <div class="pure-control-group" style="line-height: 50px;">
            <label for="email">Email Address</label>
            <input id="email" class="pure-input-1-2" type="email" placeholder="Email Address" v-model="email">
          </div>

          <div class="pure-controls" style="margin-left: 180px;">
            <button type="reset" value="Reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="back()">Cancel</button>
            <button type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="confirm()">Confirm</button>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  <modal v-if="showModal" @close="showModal = false"/>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {
  getDataUrl,
  getSendMailUrl
} from '../../tools/getUrl.js';
import router from '../../router.js';
import Modal from '../../tools/Modal';
export default {
  components: {
    Modal
  },
  data: function() {
    return {
      email: '',
      showModal: false
    };
  },
  methods: {
    confirm: function() {
      var strEmail = this.email.trim(),
        obj = {
          api: 'check_account',
          email: strEmail
        },
        url = getDataUrl(obj);
      this.$http.get(url).then((response) => {
        // success callback
        var datums = response.data;
        if (datums == 1) {

          obj = {
            email: strEmail
          };
          url = getSendMailUrl('resetpsw.php', obj);
          sessionStorage.setItem('forgetpswLink', url);
          sessionStorage.setItem('forgetpswEmail', strEmail);
          this.showModal = true;
          this.$http.get(url).then((response) => {
            // success callback
            var datums = response.data;
            if (!!datums) {
              this.showModal = false;
              router.push('/ResendMail');
            }
          }, (response) => {
            // error callback
          });

        } else {
          alert('The email account you entered does not exist. Please check again.');
        }
      }, (response) => {
        // error callback
      });

    },
    back: function() {
      router.push('/');
    }
  }
};
</script>



// WEBPACK FOOTER //
// Forgetpsw.vue?551f34ce